import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import UsersTable from "pages/admin-users/UsersTable";
import { login } from "actions/auth";
import { getAllProducts } from "actions/products";
import { useHistory } from "react-router-dom";
import UserOrdersTable from "pages/admin-users/UserOrdersTable";
import UserDecision from "pages/admin-users/UserDecision";
import {
  getAllSubmittedUsers,
  getSearchedSubmittedUsers,
  updateUserStatus,
  getAllSubmittedUsersCSV,
} from "actions/user";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import StoreTable from "pages/my-stores/stores/StoresTable";
import { Container, TabsWrapper } from "styles/pages/admin-users";
import { CSVLink } from "react-csv";

const take = 10;

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div hidden={value !== index} {...other}>
      {value === index && children}
    </div>
  );
};

const AdminUsers = () => {
  const csvEl = useRef(null);
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state?.auth);
  const token = useSelector((state) => state?.auth?.profile?.token);
  const [allUsers, setAllUsers] = useState(undefined);
  const [searchUser, setSearchUser] = useState(undefined);
  const [currentUsersPage, setCurrentUsersPage] = useState(1);
  const [selectedTab, setTab] = useState(0);
  const [allSubmittedUsers, setAllSubmittedUsers] = useState(undefined);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userAutomation, setUserAutomation] = useState(false);
  const [pendingUser, setPendingUser] = useState(false);

  useEffect(async () => {
    const skip =
      (currentUsersPage === 0 ? currentUsersPage : currentUsersPage - 1) * take;

    const users = searchUser
      ? await dispatch(
          getSearchedSubmittedUsers({
            searchUser: searchUser,
            skip,
            take,
          })
        )
      : await dispatch(
          getAllSubmittedUsers(
            {
              skip,
              take,
            },
            token
          )
        );

    if (users.error) {
      return;
    }
    setAllSubmittedUsers(users);
  }, [dispatch, currentUsersPage, searchUser]);

  return (
    <Container>
      <div className={classes.root}>
        <Grid container>
          <Grid item xs={12} sm={12} md={4}>
            <div className={classes.paper}>
              <UsersTable
                users={allSubmittedUsers}
                selectedUser={selectedUser}
                take={take}
                currentPage={currentUsersPage}
                loginToUser={async (data) => {
                  const request = await dispatch(
                    login({
                      email: data?.User,
                      password: data?.UserData?.User?.PasswordHash,
                    })
                  );
                  if (request?.error) {
                    return;
                  }
                  await dispatch(getAllProducts(auth));
                  history.replace("/");
                }}
                updateUserStatus={async (payload) => {
                  const users = await dispatch(updateUserStatus(payload));
                  if (users.error) {
                    return;
                  }
                  setAllSubmittedUsers({
                    ...allSubmittedUsers,
                    users: allSubmittedUsers?.users.map((item) =>
                      item?.User === payload?.user
                        ? {
                            ...item,
                            UserData: {
                              ...item?.UserData,
                              Status: payload?.status,
                            },
                          }
                        : item
                    ),
                  });
                }}
                searchUser={async (searchUser) => {
                  setSelectedUser(null);
                  setCurrentUsersPage(0);
                  setSearchUser(searchUser);
                }}
                fetchAllUser={async () => {
                  setSelectedUser(null);
                  setSearchUser(null);
                  if (currentUsersPage != 1) {
                    setCurrentUsersPage(1);
                    return;
                  }
                  const users = await dispatch(
                    getAllSubmittedUsers(
                      {
                        skip: 0,
                        take,
                      },
                      token
                    )
                  );
                  if (users.error) {
                    return;
                  }
                  setAllSubmittedUsers(users);
                }}
                setCurrentPage={(v) => {
                  setSelectedUser(null);
                  setCurrentUsersPage(v);
                }}
                setSelectedUser={(user) => {
                  setSelectedUser(user);
                  setTab(0);
                }}
                getAllUsers={async () => {
                  const skip =
                    (currentUsersPage === 0
                      ? currentUsersPage
                      : currentUsersPage - 1) * take;

                  const usersData = await dispatch(
                    getAllSubmittedUsers(
                      {
                        skip,
                        take,
                      },
                      token
                    )
                  );

                  if (usersData.error) {
                    return;
                  }
                  setAllSubmittedUsers(usersData);

                  const users = await dispatch(getAllSubmittedUsersCSV());

                  if (users.error) {
                    return;
                  }

                  let data = [["First Name", "Last Name", "Email"]];

                  for (let i = 0; i < users?.length; i++) {
                    const name = users[i]?.first_name.split(" ");
                    data.push([
                      name[0],
                      name?.length > 1 ? name.splice(1).join(" ") : "",
                      users[i]?.email,
                    ]);
                  }

                  setAllUsers(data);
                  setTimeout(() => {
                    csvEl.current.link.click();
                  }, 10);
                }}
                userAutomation={userAutomation}
                pendingUser={pendingUser}
                setPendingUser={async (v) => {
                  setUserAutomation(false);
                  setPendingUser(v);
                  const users = await dispatch(
                    getAllSubmittedUsers(
                      {
                        skip: 0,
                        take,
                        pendingUser: v,
                      },
                      token
                    )
                  );
                  if (users.error) {
                    return;
                  }
                  setAllSubmittedUsers(users);
                }}
                setUserAutomation={async (v) => {
                  setUserAutomation(v);
                  setPendingUser(false);
                  const users = await dispatch(
                    getAllSubmittedUsers(
                      {
                        skip: 0,
                        take,
                        automation: v,
                      },
                      token
                    )
                  );
                  if (users.error) {
                    return;
                  }
                  setAllSubmittedUsers(users);
                }}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={8}>
            {selectedUser && (
              <div className={classes.paper}>
                <AppBar
                  position="static"
                  style={{
                    backgroundColor: "transparent",
                    color: "rgb(28, 132, 198)",
                    marginBottom: 20,
                  }}
                >
                  <TabsWrapper>
                    <Tabs value={selectedTab} onChange={(e, v) => setTab(v)}>
                      <Tab label="Orders" />
                      <Tab label="Stores" />
                      <Tab label="Decision" />
                    </Tabs>
                  </TabsWrapper>
                </AppBar>

                <TabPanel value={selectedTab} index={0}>
                  <UserOrdersTable user={selectedUser} />
                </TabPanel>
                <TabPanel value={selectedTab} index={1}>
                  <StoreTable userEmail={selectedUser?.User} />
                </TabPanel>
                <TabPanel value={selectedTab} index={2}>
                  <UserDecision
                    user={selectedUser}
                    fetchAllUser={async () => {
                      setSelectedUser(null);
                      setSearchUser(null);
                      if (currentUsersPage != 1) {
                        setCurrentUsersPage(1);
                        return;
                      }
                      const users = await dispatch(
                        getAllSubmittedUsers(
                          {
                            skip: 0,
                            take,
                          },
                          token
                        )
                      );
                      if (users.error) {
                        return;
                      }
                      setAllSubmittedUsers(users);
                    }}
                  />
                </TabPanel>
              </div>
            )}
          </Grid>
        </Grid>
      </div>
      {allUsers && (
        <CSVLink
          style={{ display: "none" }}
          ref={csvEl}
          data={allUsers}
          filename={`BOT_Users_List.xls`}
        />
      )}
    </Container>
  );
};

export default AdminUsers;
